module.exports = __webpack_public_path__ + "static/media/20_000019.a1c2981c.jpg";